import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import img from 'assets/images/rocket.jpg';
import Service from './Service';
import Tv from 'assets/images/svg/Tv';
import World from 'assets/images/svg/World';
import Phone from 'assets/images/svg/Phone';
import Server from 'assets/images/svg/Server';
import SpeedIcon from '@mui/icons-material/Speed';
import RouterIcon from '@mui/icons-material/Router';
import SimCardIcon from '@mui/icons-material/SimCard';
import FourGMobiledataIcon from '@mui/icons-material/FourGMobiledata';
import WifiIcon from '@mui/icons-material/Wifi';
import TtyIcon from '@mui/icons-material/Tty';

function ServiceSection() {
  return (
    <Box component={'section'} position={'relative'} minHeight={422}>
      <Box
        sx={{
          overflow: 'hidden',
          minHeight: 422,
          paddingTop: '60px',
          paddingBottom: '90px',
        }}>
        <Box sx={{ position: 'relative', zIndex: 3 }}>
          <Grid className="container" container color={'white'}>
            <Grid item xs={12}>
              <Typography
                variant="h4"
                textAlign={'center'}
                color={'text.primary'}
                fontWeight={600}>
                خدمات
              </Typography>
            </Grid>

            <Grid item xs={12} sx={{ mt: 10 }}>
              <Grid container spacing={2} justifyContent={'center'}>
                <Grid item xs={7} sm={6} md={3} xl={2} sx={{ display: 'flex' }}>
                  <Service
                    icon={
                      <SpeedIcon
                        sx={{ fontSize: '2.1rem', color: 'primary.main' }}
                      />
                    }
                    title="فیبر"
                    desc={
                      'ویژگی‌های منحصر به فرد این فناوری، عدم نیاز به خط تلفن ثابت است چون این سرویس تنها با تکنولوژی فیبر نوری و مودم اختصاصی راه‌انداری می‌شود'
                    }
                    path={'/fiber'}
                  />
                </Grid>
                <Grid item xs={7} sm={6} md={3} xl={2} sx={{ display: 'flex' }}>
                  <Service
                    icon={
                      <RouterIcon
                        sx={{ fontSize: '2.1rem', color: 'primary.main' }}
                      />
                    }
                    title={'ADSL+2'}
                    desc={
                      'اینترنت پرسرعت و بدون قطعی برای کاربران خانگی و اداری در کلیه مناطق مخابراتی ۳۱ استان کشور با پشتیبانی ۲۴ ساعته در ۷ روز هفته'
                    }
                    path={'/adsl'}
                  />
                </Grid>
                <Grid item xs={7} sm={6} md={3} xl={2} sx={{ display: 'flex' }}>
                  <Service
                    icon={
                      <SimCardIcon
                        sx={{ fontSize: '2.1rem', color: 'primary.main' }}
                      />
                    }
                    title={'TD-LTE'}
                    desc={
                      'اینترنت بدون نیاز به خط تلفن ثابت، پهنای باند بسیار بالا و نیز ارائه مودم با قابلیت جابه‌جایی و امکان دریافت سرویس در تمامی مناطق تحت پوشش در سراسر کشور'
                    }
                    path={'/td-lte'}
                  />
                </Grid>
                <Grid item xs={7} sm={6} md={3} xl={2} sx={{ display: 'flex' }}>
                  <Service
                    icon={
                      <WifiIcon
                        sx={{ fontSize: '2.1rem', color: 'primary.main' }}
                      />
                    }
                    title={'OWA'}
                    desc={
                      'سرویس مناسب کاربران حرفه‌ای اینترنت (نظیر گیمرها و استریمرها) بوده و سرعت آپلود و دانلود و پایداری بسیار بالایی و پایداری بالا، بدون نیاز به خط تلفن ثابت'
                    }
                    path={'/owa'}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}

export default ServiceSection;
